"use client";

import { useAdmin } from "@/lib/admin/context";
import { Icon } from "@/lib/icons/Icon";
import styles from "./AdminPanelLink.module.css";

/**
 * "Panel admina ↗" — link do classic Imperial admin (`IADMIN`) w nowej karcie.
 *
 * Pierwszy element top bara od lewej (zob. AdminTopBar layout). URL pochodzi
 * z `adminPanelUrl` w AdminContext (build'owany server-side z
 * `IMPERIAL_API_BASE_*` env var w PublicLayout).
 */
export function AdminPanelLink() {
  const { adminPanelUrl, t } = useAdmin();

  return (
    <a
      href={adminPanelUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={styles.link}
      title={t.topBar.adminPanelLink.title}
    >
      <span className={styles.label}>{t.topBar.adminPanelLink.label}</span>
      <Icon name="arrow-square-out" className={styles.icon} />
    </a>
  );
}
